import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="py-24 px-6 bg-white" data-id="element-94">
      <div className="max-w-4xl mx-auto text-center" data-id="element-95">
        <motion.div className="bg-brand-green text-white p-8 md:p-16 rounded-3xl shadow-2xl relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-96">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold rounded-full opacity-10 blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-97"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-rose rounded-full opacity-10 blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-98"></div>

          <div className="relative z-10" data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-cream" data-id="element-100">
              Tu momento es ahora
            </h2>
            <p className="text-lg md:text-xl mb-10 text-brand-cream/90 max-w-2xl mx-auto leading-relaxed" data-id="element-101">
              Recupera el control de tu cuerpo hoy por una fracción de lo que
              costaría una consulta nutricional o un suplemento que terminará en
              la basura.
            </p>

            <div className="mb-10" data-id="element-102">
              <span className="block text-sm uppercase tracking-widest text-brand-gold font-bold mb-2" data-id="element-103">
                Acceso Inmediato por solo
              </span>
              <div className="text-2xl md:text-3xl text-brand-cream/60 line-through font-medium mb-1" data-id="element-104">
                $19.00 USD
              </div>
              <div className="text-5xl md:text-7xl font-black text-white drop-shadow-md" data-id="element-105">
                $6.39{' '}
                <span className="text-2xl md:text-3xl font-medium text-brand-cream/80" data-id="element-106">
                  USD
                </span>
              </div>
              <span className="inline-block mt-3 bg-brand-gold/20 text-brand-gold text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wide" data-id="element-107">
                ¡Ahorra 66%!
              </span>
            </div>

            <CTAButton className="bg-brand-gold text-brand-green hover:bg-yellow-500" data-id="element-108" />
          </div>
        </motion.div>
      </div>
    </section>;
}